import { render, staticRenderFns } from "./AuctionTitle.vue?vue&type=template&id=5ea009e5&scoped=true&"
import script from "./AuctionTitle.vue?vue&type=script&lang=js&"
export * from "./AuctionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea009e5",
  null
  
)

export default component.exports